import { TextFormField } from 'types';
import { RichTextPreview } from 'components/rich-text-preview';
import { defaultLanguage, useTranslationContext } from 'context';

export const FormText = ({ text, translations }: TextFormField) => {
  const { language } = useTranslationContext();
  const content =
    language && language !== defaultLanguage
      ? translations?.[language]?.text || text
      : text;
  return (
    <section className="col-span-full w-full py-2">
      <RichTextPreview content={content} allowImages={false} />
    </section>
  );
};
